[
  "cat",
  "dog",
  "run",
  "big",
  "red",
  "sun",
  "hat",
  "top",
  "can",
  "see",
  "the",
  "and",
  "you",
  "for",
  "are",
  "have",
  "they",
  "one",
  "two",
  "go",
  "up",
  "down",
  "in",
  "out",
  "yes",
  "no",
  "mom",
  "dad",
  "boy",
  "girl",
  "hot",
  "sit",
  "ran",
  "car",
  "put",
  "bus",
  "bat",
  "box",
  "fox",
  "bed",
  "leg",
  "ant",
  "hen",
  "pig",
  "bug",
  "cup",
  "fun",
  "sad",
  "pet",
  "ten",
  "wet",
  "pan",
  "van",
  "six",
  "nap",
  "mat",
  "fan",
  "pin",
  "cut",
  "map",
  "jog",
  "dug",
  "hug",
  "rug",
  "zip",
  "log",
  "jam",
  "web",
  "jet",
  "mud",
  "sam",
  "pam",
  "tim",
  "kim",
  "ben",
  "jen",
  "dan",
  "ron",
  "tom",
  "bob",
  "dot",
  "pot",
  "mop",
  "pop",
  "sip",
  "dip",
  "lip",
  "hip",
  "tip",
  "tap",
  "gap",
  "cap",
  "lap",
  "nod",
  "pod",
  "rod",
  "sob",
  "cob",
  "mob",
  "rob",
  "nut",
  "gut",
  "tub",
  "rub",
  "cub",
  "sub",
  "bun",
  "gun",
  "nun",
  "sun",
  "sum",
  "gum",
  "hum",
  "beg",
  "peg",
  "den",
  "pen",
  "men",
  "net",
  "get",
  "set",
  "vet",
  "bib",
  "rib",
  "cot",
  "lot",
  "hop",
  "sop",
  "tot",
  "got",
  "not",
  "rat",
  "sat",
  "fat",
  "pat",
  "bag",
  "tag",
  "rag",
  "wag",
  "hid",
  "bid",
  "kid",
  "lid",
  "rid",
  "hop",
  "cop",
  "cob",
  "job",
  "bit",
  "fit",
  "hit",
  "kit",
  "lit",
  "pit",
  "wit",
  "bad",
  "had",
  "mad",
  "pad",
  "lad",
  "can",
  "man",
  "ran",
  "tan",
  "ban",
  "cod",
  "god",
  "nod",
  "sob",
  "bud",
  "cud",
  "fed",
  "led",
  "red",
  "ted",
  "wed",
  "beg",
  "keg",
  "bin",
  "fin",
  "sin",
  "tin",
  "win",
  "dim",
  "him",
  "rim",
  "fox",
  "six",
  "mix",
  "fix",
  "pox",
  "tux",
  "tag",
  "jog",
  "hog",
  "fog",
  "jug",
  "mug",
  "tug"
]
